<template>
  <div
    :class="{ 'cb-troubleshoot--has-title': title }"
    class="cb-troubleshoot"
    @keydown="handleKeypress"
  >
    <h2
      class="cb-troubleshoot__header cb-heading-4"
      v-if="title"
      tabindex="-1"
      ref="title"
      id="dialog-title"
    >
      Troubleshoot your CellBridge device
    </h2>
    <div class="cb-troubleshoot__content">
      <ol>
        <li>
          <cb-accordion :tabOrder="'first'">
            <p class="cb-body-1 question" slot="question">
              How do I install my CellBridge device?
            </p>
            <div class="cb-body-1 answer" slot="answer">
              Please plug-in the CellBridge device within 25 feet of your alarm
              box, and do not use an extension cord or power strip.
            </div>
          </cb-accordion>
        </li>
        <li>
          <cb-accordion>
            <p class="cb-body-1 question" slot="question">
              What do the lights on my CellBridge device mean?
            </p>
            <div class="cb-body-1 answer" slot="answer">
              Lights on CellBridge device shows the status of device, if it’s
              ready for installation.
            </div>
          </cb-accordion>
        </li>
        <li>
          <cb-accordion>
            <p class="cb-body-1 question" slot="question">
              My device Power LED = Blinking Yellow or Red.
            </p>
            <div class="cb-body-1 answer" slot="answer">
              <ul>
                <li>Confirm that the power cable is plugged in.</li>
                <li>Confirm that the breaker/switch for the outlet is on.</li>
              </ul>
            </div>
          </cb-accordion>
        </li>
        <li>
          <cb-accordion>
            <p class="cb-body-1 question" slot="question">
              4G LTE LED = Solid or Blinking Red.
            </p>
            <div class="cb-body-1 answer" slot="answer">
              Try re-locating the CB34U to another suitable location with better
              LTE reception.
            </div>
          </cb-accordion>
        </li>
        <li>
          <cb-accordion>
            <p class="cb-body-1 question" slot="question">
              3G LED = Solid Red.
            </p>
            <div class="cb-body-1 answer" slot="answer">
              <ul>
                <li>Confirm that the alarm panel is powered on.</li>
                <li>Try re-locating the CB34U closer to the Alarm Panel.</li>
              </ul>
            </div>
          </cb-accordion>
        </li>
        <li>
          <cb-accordion>
            <p class="cb-body-1 question" slot="question">
              Status LED = Solid or Blinking Yellow.
            </p>
            <div class="cb-body-1 answer" slot="answer">
              The back panel may not be properly connected. Please contact care
              for additional assistance.
            </div>
          </cb-accordion>
        </li>
        <li>
          <cb-accordion>
            <p class="cb-body-1 question" slot="question">
              Status LED = Solid or Blinking Red.
            </p>
            <div class="cb-body-1 answer" slot="answer">
              The battery may not be properly connected. Please contact care for
              additional assistance.
            </div>
          </cb-accordion>
        </li>
      </ol>
    </div>
    <div class="cb-troubleshoot__btn-container">
      <button
        @click="closeModal"
        class="cb-button cb-button--blue"
        ref="closeModalButton"
        v-if="isModalOpen"
      >
        Close
      </button>
      <button @click="handleTryAgain" class="cb-button cb-button--blue" v-else>
        {{ buttonText || 'Go Back' }}
      </button>
      <!-- <button
        @click="handleLiveChatClick"
        :disabled="isLiveChatOpen || isLiveChatExpanded"
        class="cb-button cb-button--outline cb-button--live-chat"
        v-if="showLiveChat"
      >
        Live Chat
        <span class="cb-button--live-chat__icon"></span>
      </button> -->
    </div>
    <cb-assistance :tabOrder="'last'"></cb-assistance>
  </div>
</template>

<script>
/* global gtag */
import { mapActions, mapMutations, mapState } from 'vuex';
// import isLivechatActive from '../utility/livechat';
import Accordion from './shared/Accordion.vue';
import Assistance from './shared/Assistance.vue';
import focusTrapping from '../mixins/focusTrapping';

export default {
  props: ['title'],
  // data() {
  //   return {
  //     showLiveChat: false,
  //   };
  // },
  // beforeMount() {
  //   this.showLiveChat = isLivechatActive();
  // },
  mounted() {
    if (this.isModalOpen) {
      this.$refs.closeModalButton.focus();
    }
    document.title = 'CellBridge - Troubleshoot your CellBridge device';
  },
  computed: {
    ...mapState({
      isModalOpen: (state) => state.modal.isOpen,
      // isLiveChatOpen: (state) => state.isLiveChatOpen,
      // isLiveChatExpanded: (state) => state.isLiveChatExpanded,
      buttonText: (state) => state.troubleshoot.buttonText,
    }),
  },
  methods: {
    handleTryAgain() {
      if (this.buttonText) {
        this.updateManualTestStep('1');
        this.$router.push('/setup-test');
        gtag('event', 'tryAgainClick', {
          event_label: 'try again',
          event_category: 'troubleshoot',
          value: 1,
        });
      } else {
        this.$router.go(-1);
        gtag('event', 'goBackClick', {
          event_label: 'go back',
          event_category: 'troubleshoot',
          value: 1,
        });
      }
      this.updateTroubleshootPage({ buttonText: '' });
    },
    // handleLiveChatClick() {
    //   this.toggleLiveChat();
    //   gtag('event', 'liveChatClick', {
    //     event_label: 'live chat',
    //     event_category: 'troubleshoot',
    //     value: 1,
    //   });
    // },
    handleKeypress(e) {
      if (this.title) {
        this.setFocus(e);
      }
    },
    ...mapActions(['closeModal']),
    ...mapMutations(['updateManualTestStep', 'updateTroubleshootPage']),
  },
  mixins: [focusTrapping],
  components: {
    cbAccordion: Accordion,
    cbAssistance: Assistance,
  },
};
</script>

<style lang="scss" scoped>
.cb-troubleshoot {
  &--has-title {
    width: 88vw;
    max-width: 658px;
    box-sizing: border-box;
    padding: 28px 20px 28px;
  }

  &__header {
    margin-bottom: 28px;
  }

  &__btn-container {
    margin: 28px 0 12px;

    .cb-button {
      width: 100%;
      margin-bottom: 16px;
    }
  }

  ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  @include tablet {
    &__header {
      text-align: center;
    }
  }

  @include desktop {
    &--has-title {
      padding: 40px 40px 28px;

      .cb-troubleshoot__content {
        max-height: 313px;
        overflow-y: scroll;
      }
    }

    &__btn-container {
      display: flex;
      justify-content: center;

      .cb-button {
        width: 175px;
      }

      button {
        &:first-of-type {
          margin-right: 10px;
        }

        &:last-of-type {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
